module.exports = __webpack_public_path__ + "img/google.play.027fe803.png";